<template>
  <div class="lvmmed-oauth-callback">
    <div class="callback-card">
      <h2>Liên kết LVMMED</h2>
      <p>{{ statusMessage }}</p>
      <button v-if="canClose" type="button" class="btn-close" @click="closeWindow">Đóng cửa sổ</button>
    </div>
  </div>
</template>

<script>
import lvmmedService from '@/services/lvmmedService'

const OAUTH_STATE_STORAGE_KEY = 'hodo_lvmmed_oauth_state'

function parseQueryParams () {
  const url = new URL(window.location.href)
  const searchParams = new URLSearchParams(url.search || '')

  const hash = window.location.hash || ''
  const hashQueryIndex = hash.indexOf('?')
  const hashParams = new URLSearchParams(hashQueryIndex >= 0 ? hash.slice(hashQueryIndex + 1) : '')

  const code = searchParams.get('code') || hashParams.get('code') || ''
  const state = searchParams.get('state') || hashParams.get('state') || ''
  const error = searchParams.get('error') || hashParams.get('error') || ''
  const errorDescription = searchParams.get('error_description') || hashParams.get('error_description') || ''

  return { code, state, error, errorDescription }
}

export default {
  name: 'LvmmedOauthCallback',
  data () {
    return {
      statusMessage: 'Đang xử lý liên kết tài khoản LVMMED...',
      canClose: false
    }
  },
  async mounted () {
    await this.handleOAuthCallback()
  },
  methods: {
    notifyOpener (payload) {
      if (!window.opener || window.opener.closed) return
      window.opener.postMessage(
        {
          type: 'LVMMED_OAUTH_RESULT',
          ...payload
        },
        window.location.origin
      )
    },
    markDone (message, payload = {}) {
      this.statusMessage = message
      this.canClose = true
      this.notifyOpener(payload)
      setTimeout(() => {
        this.closeWindow()
      }, 1000)
    },
    async handleOAuthCallback () {
      const { code, state, error, errorDescription } = parseQueryParams()
      if (error) {
        const message = errorDescription || `OAuth trả về lỗi: ${error}.`
        this.markDone(`Liên kết LVMMED thất bại. ${message}`, {
          success: false,
          message
        })
        return
      }

      if (!code || !state) {
        this.markDone('Thiếu thông tin xác thực OAuth. Vui lòng thử lại.', {
          success: false,
          message: 'Thiếu code hoặc state OAuth.'
        })
        return
      }

      const expectedState = window.localStorage.getItem(OAUTH_STATE_STORAGE_KEY)
      if (!expectedState || expectedState !== state) {
        this.markDone('Xác thực OAuth không hợp lệ (state mismatch). Vui lòng thử lại.', {
          success: false,
          message: 'State OAuth không hợp lệ.'
        })
        return
      }

      try {
        await lvmmedService.oauthCallback({ code, state })
        window.localStorage.removeItem(OAUTH_STATE_STORAGE_KEY)
        this.markDone('Liên kết LVMMED thành công.', {
          success: true,
          message: 'Liên kết LVMMED thành công.'
        })
      } catch (error) {
        const message = error?.response?.data?.message || 'Liên kết LVMMED thất bại. Vui lòng thử lại.'
        this.markDone(message, {
          success: false,
          message
        })
      }
    },
    closeWindow () {
      window.close()
    }
  }
}
</script>

<style scoped>
.lvmmed-oauth-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 24px;
}

.callback-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
}

.callback-card h2 {
  margin: 0 0 12px;
  font-size: 20px;
  color: #0f172a;
}

.callback-card p {
  margin: 0;
  color: #334155;
}

.btn-close {
  margin-top: 16px;
  border: 0;
  border-radius: 8px;
  background: #20419b;
  color: #fff;
  font-size: 14px;
  padding: 8px 14px;
}
</style>
